"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var Pay = function Pay(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "Pay"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "pay"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.96 4.76l2.080-2.24v7.48c0 0.398 0.322 0.72 0.72 0.72s0.72-0.322 0.72-0.72v0-7.48l2.1 2.24c0.131 0.136 0.315 0.22 0.518 0.22 0.001 0 0.001 0 0.002 0h-0c0.001 0 0.002 0 0.004 0 0.183 0 0.35-0.068 0.477-0.181l-0.001 0.001c0.131-0.13 0.212-0.311 0.212-0.51s-0.081-0.38-0.212-0.51l-0-0-3.3-3.56c-0.129-0.125-0.306-0.202-0.5-0.202s-0.371 0.077-0.5 0.202l0-0-3.38 3.58c-0.131 0.13-0.212 0.311-0.212 0.51s0.081 0.38 0.212 0.51l0 0c0.13 0.126 0.307 0.204 0.503 0.204 0.224 0 0.424-0.102 0.556-0.263l0.001-0.001zM17.38 6.66c-0.398 0-0.72 0.322-0.72 0.72s0.322 0.72 0.72 0.72v0c0 0 0 0 0 0 0.656 0 1.189 0.526 1.2 1.179l0 0.001v5.48h-17.16v-5.48c0.011-0.654 0.544-1.18 1.2-1.18 0 0 0 0 0 0h9.28c0.398 0 0.72-0.322 0.72-0.72s-0.322-0.72-0.72-0.72v0h-9.28c-1.447 0-2.62 1.173-2.62 2.62v0 8.1c0 1.447 1.173 2.62 2.62 2.62v0h14.76c1.447 0 2.62-1.173 2.62-2.62v0-8.1c0-1.447-1.173-2.62-2.62-2.62v0zM17.38 18.58h-14.76c-0.663 0-1.2-0.537-1.2-1.2v0-1.2h17.16v1.2c0 0.663-0.537 1.2-1.2 1.2v0zM5.54 9.68c-0.218-0.095-0.473-0.15-0.74-0.15-1.049 0-1.9 0.851-1.9 1.9s0.851 1.9 1.9 1.9c0.267 0 0.522-0.055 0.752-0.155l-0.012 0.005c-0.478-0.434-0.777-1.057-0.777-1.75s0.299-1.316 0.775-1.748l0.002-0.002z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = Pay;
exports["default"] = _default;